import Spinner from "@/components/Spinner";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { pushModal } from "../../../../store/slices/modalsSlice";
import GeneralMessageModal from "../../../Modals/GeneralMessageModal";
import { fetchQuestions } from "../utils";

const FetchQuestions = ({
  isLoading,
  teacherBankCats,
  setQuestionsData,
  setIsLoading,
}) => {
  const [chosenCat, setChosenCat] = useState(null);
  const { userProfileData } = useAppSelector((state) => state.store);
  const dispatch = useAppDispatch();

  const errorFn = () => {
    dispatch(pushModal(<GeneralMessageModal msg="حدث خطأ" btnMsg="حسنا" />));
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        fetchQuestions({
          cat: chosenCat,
          setQuestionsData,
          setIsLoading,
          errorFn,
        });
      }}
      className="p-3"
    >
      <h4
        style={{ textAlign: "center" }}
        className="mt-3 mb-4 bg-primary py-2 px-3 text-white rounded-lg shadow font-bold"
      >
        عرض الأسئلة
      </h4>
      <div className="flex flex-col gap-4">
        <select
          className="px-2 py-1 rounded-lg border border-gray-400 w-full md:w-[30%] md:min-w-fit focus:ring-(--primary-color-light)"
          value={chosenCat}
          onChange={(e) => setChosenCat(e.target.value)}
          required
        >
          <option>إختر المجموعة</option>
          {teacherBankCats.map((ans) => (
            <option value={ans}>
              {ans.indexOf(` - ${userProfileData.teacher_prefix}`) > -1
                ? ans.replace(` - ${userProfileData.teacher_prefix}`, "")
                : ans}
            </option>
          ))}
        </select>
        <Button
          type="submit"
          disabled={isLoading}
          id="publish_new_quiz_submit"
          className="px-2 py-1 rounded-lg border border-gray-400 w-full md:w-[30%] md:min-w-fit focus:ring-(--primary-color-light) "
        >
          {isLoading ? <Spinner variant="button" /> : "بحث"}
        </Button>
      </div>
    </form>
  );
};

export default FetchQuestions;
